// Release date of the initial MCP launch (v1.0). Not derivable from the repo
// (the MCP server and this page are newer than their git history). Left empty
// until the real date is known — the date line is simply omitted when unset,
// so nothing placeholder-like ships. Set this string to surface the date.
const INITIAL_RELEASE_DATE = "July 1, 2026"

const RELEASES = [
  {
    version: "2.1",
    date: "July 27, 2026",
    groups: [
      {
        label: "Added",
        items: [
          <>
            <code>change_alert_status</code> tool (<code>mcp:alerts:write</code>): changes the
            status of a single alert. It works the same as on the platform and follows the same
            rules and restrictions. This is the MCP&apos;s first and only write action.
          </>,
          <>
            A third connect-time permission, <strong>change alert statuses</strong>, alongside the
            existing
            <strong> read alerts</strong> and <strong>read business accounts</strong>. Grant all
            three for full functionality, or only the ones you want.
          </>,
          <>
            A <strong>Change an alert&apos;s status</strong> entry in the <em>What it can do</em>{" "}
            list.
          </>
        ]
      },
      {
        label: "Changed",
        items: [
          <>
            Capability badge is now <strong>Read + write</strong> (was <strong>Read-only</strong>).
            Reading and changing status are separate, independently granted permissions.
          </>,
          "Tool count went from four to five: four read-only tools plus one write tool.",
          "Connect instructions for every client now cover the third permission (keep all three permission boxes checked).",
          <>
            The <em>What it can&apos;t do</em> list now clarifies that the assistant can change an
            alert&apos;s status but nothing else on an alert, and still cannot create or delete
            alerts or change account settings.
          </>,
          <>
            The <em>Limitations</em> section replaces the &quot;read-only, cannot take action&quot;
            note with &quot;the only write action is changing an alert&apos;s status.&quot;
          </>
        ]
      },
      {
        label: "Security",
        items: [
          "Security & permissions guidance updated for the optional write permission: read access carries no risk, the write permission is opt-in, and you can keep the connection read-only.",
          "Prompt-injection note expanded: granting write raises the risk that an injected instruction could change an alert's status, so enabling a human-in-the-loop confirmation is recommended once write is on."
        ]
      }
    ]
  },
  {
    version: "1.0",
    date: INITIAL_RELEASE_DATE,
    groups: [
      {
        label: "Added",
        items: [
          "Initial release of the Chargeback MCP, a Model Context Protocol server with OAuth 2.1 authentication and per-user data isolation.",
          <>
            Four read-only tools: <code>list_alerts</code> and <code>get_alert</code> (
            <code>mcp:alerts:read</code>),
            <code> list_business_accounts</code> and <code>get_business_account</code> (
            <code>mcp:business_accounts:read</code>).
          </>,
          <>
            Connect-time permissions for <strong>read alerts</strong> and{" "}
            <strong>read business accounts</strong>.
          </>,
          "Verbose mode on all tools; customer personal data masked in every mode.",
          "Setup guides for Claude, Claude Code, ChatGPT, Cursor, Codex, Grok, Mistral AI, Devin, Antigravity IDE, and any other streamable-HTTP / OAuth 2.1 client."
        ]
      }
    ]
  }
]

const Changelog = () => (
  <div className="mcp-doc-changelog">
    {RELEASES.map((release) => (
      <div
        key={release.version}
        id={`changelog-${release.version.replace(".", "-")}`}
        className="mcp-doc-changelog-release"
      >
        <div className="mcp-doc-changelog-head">
          <span className="mcp-doc-changelog-version">v{release.version}</span>
          {release.date && <span className="mcp-doc-changelog-date">{release.date}</span>}
        </div>
        {release.groups.map((group) => (
          <div key={group.label} className="mcp-doc-changelog-group">
            <div className="mcp-doc-changelog-group-label">{group.label}</div>
            <ul className="mcp-doc-changelog-list">
              {group.items.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    ))}
  </div>
)

export default Changelog
